import React, { useState } from "react";
import OTPInput from "react-otp-input";
import PropTypes from "prop-types";
import { Box, Button, CircularProgress, Typography } from "@mui/material";

import { ResendOTPButton } from "pages/Home/ForgotPasswordModal";
import Modal from "Components/Common/Modal";
import { otpVerificationType } from "common/constant";
import useCountdown from "hooks/useCountDown";
import Backdrop from "./Backdrop";

import { filterEmptyStrings } from "utils";

import { useRequestOTPMutation, useValidateOTPPutMutation } from "apis/OTP";

const VerifyEmailModal = ({
  isOpen,
  handleClose,
  handleOTPverificationSuccess = () => {},
  handleOTPVerificationFailed = () => {},
  email,
  mobileNumber,
  isLoading,
  requestOTPType = otpVerificationType["Verification"],
  isFireSafety,
}) => {
  const [emailOtp, setEmailOtp] = useState("");
  const [mobileOtp, setMobileOtp] = useState("");
  const [error, setError] = useState("");
  const [requestOTP] = useRequestOTPMutation();
  const [isEnableResendOTP, setIsEnableResendOTP] = useState(false);

  const [verifyOTP, { isLoading: isVerifyingOTP }] =
    useValidateOTPPutMutation();

  const handleEmailChangeOtp = (OTP) => {
    setError("");
    setEmailOtp(OTP);
  };
  const handleMobileChangeOtp = (OTP) => {
    setError("");
    setMobileOtp(OTP);
  };
  const handleCountdownFinished = () => {
    setIsEnableResendOTP(true);
  };

  const { minutes, seconds, startTimer, resetTimer } = useCountdown(
    0,
    2,
    0,
    handleCountdownFinished
  );

  const handleValidateOTP = () => {
    if (
      emailOtp ||
      (mobileOtp && requestOTPType === otpVerificationType["Verification"])
    ) {
      if (
        emailOtp.length !== 6 ||
        (mobileOtp.length !== 6 &&
          requestOTPType === otpVerificationType["Verification"])
      ) {
        setError("OTP Must be exactly 6 digits");
      } else {
        verifyEmailAndMobile();
      }
    } else {
      setError("Please Enter OTP");
    }
  };

  const verifyEmailAndMobile = async () => {
    try {
      await verifyOTP(
        filterEmptyStrings({
          emailOtp: +emailOtp,
          mobileNumberOtp: mobileOtp ? +mobileOtp : "",
          email,
          mobileNumber: mobileNumber?.toString(),
          type: requestOTPType,
        }),
        {},
        isFireSafety
      );

      handleOTPverificationSuccess();
      handleClose();
    } catch (error) {
      handleOTPVerificationFailed();
    }
  };

  const handleResendOTP = async () => {
    setIsEnableResendOTP(false);
    resetTimer();
    startTimer();
    try {
      await requestOTP(
        filterEmptyStrings({
          [email.match(/^[0-9]{10}$/) ? "mobileNumber" : "email"]: email,
          mobileNumber: mobileNumber ?? "",
          type: requestOTPType,
        }),
        "OTP generated, please check your phone or email."
      );
    } catch (err) {}
  };

  if (isOpen) {
    startTimer();
  }

  if (isLoading) {
    return <Backdrop open={isLoading} />;
  }

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      title="Verify Email"
      maxWidth="xs"
    >
      <Box>
        <Typography className="text-center m-2 fw-bold">
          {`An OTP has been sent to your email ${email} ${
            mobileNumber ? `and mobile number ${mobileNumber}` : ""
          }`}
        </Typography>
        <Typography className="p-2">Enter Email OTP here</Typography>
        <OTPInput
          value={emailOtp}
          inputStyle={
            "form-control form-control-lg bg-light border-light text-center w-25 mb-3"
          }
          containerStyle={"justify-content-between"}
          onChange={handleEmailChangeOtp}
          numInputs={6}
          inputType="number"
          renderSeparator={<span>{"\u2003"}</span>}
          shouldAutoFocus
          renderInput={(props) => <input {...props} />}
        />
        {requestOTPType === otpVerificationType["Verification"] && (
          <>
            <Typography className="p-2">
              Enter Mobile number OTP here
            </Typography>
            <OTPInput
              value={mobileOtp}
              inputStyle={
                "form-control form-control-lg bg-light border-light text-center w-25 mb-3"
              }
              containerStyle={"justify-content-between"}
              onChange={handleMobileChangeOtp}
              numInputs={6}
              inputType="number"
              renderSeparator={<span>{"\u2003"}</span>}
              shouldAutoFocus
              renderInput={(props) => <input {...props} />}
            />
          </>
        )}

        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        <Button
          variant="contained"
          size="small"
          onClick={handleValidateOTP}
          className="d-flex m-auto"
          startIcon={isVerifyingOTP ? <CircularProgress size={20} /> : null}
          disabled={isVerifyingOTP || !!error}
        >
          Submit
        </Button>
        <div className="d-flex my-1 justify-content-center mt-2 gap-2">
          <ResendOTPButton
            component="button"
            underline="none"
            onClick={handleResendOTP}
            disabled={!isEnableResendOTP}
          >
            Resend OTP
          </ResendOTPButton>
          {!isEnableResendOTP && (
            <p className="m-0">
              in {minutes}:{seconds}
            </p>
          )}
        </div>
      </Box>
    </Modal>
  );
};
VerifyEmailModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  handleOTPverificationSuccess: PropTypes.func,
  handleOTPVerificationFailed: PropTypes.func,
  mobileNumber: PropTypes.number,
  email: PropTypes.string,
  isLoading: PropTypes.bool,
  requestOTPType: PropTypes.number,
  isFireSafety: PropTypes.bool,
};

export default VerifyEmailModal;
